<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 48 48" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g><path data-follow-fill="currentColor" d="m19 24.1-11.9-6c-.5-.2-1-.4-1.6-.4-.6 0-1.3.2-1.7.6-.4.4-.7 1-.7 1.6v16c0 .8.3 1.5.8 2.1.5.7 1.2 1.2 1.9 1.6l11.9 5.9c.5.2 1 .4 1.6.4.6 0 1.3-.2 1.7-.6.4-.4.7-1 .7-1.6v-16c0-.8-.3-1.5-.8-2.1-.5-.6-1.1-1.2-1.9-1.5zm25.2-5.7c-.5-.4-1.1-.7-1.7-.6-.5 0-1.1.1-1.6.4l-11.9 6c-.8.4-1.4.9-1.9 1.6-.5.6-.7 1.3-.8 2.1v16c0 .6.2 1.2.7 1.6.5.4 1.1.7 1.7.6.5 0 1.1-.1 1.6-.4l11.9-6c.8-.4 1.4-.9 1.9-1.6.5-.6.7-1.3.8-2.1V20c0-.6-.2-1.2-.7-1.6zM40 13.2c.9-.3 1.6-1.2 1.7-2.2-.1-1-.7-1.8-1.7-2.2L26.7 2.5c-.8-.3-1.7-.5-2.6-.5-.9 0-1.9.2-2.7.5L8 9.1c-.9.3-1.6 1.2-1.7 2.2.1 1 .7 1.8 1.7 2.2l13.2 6.2c.6.3 1.2.4 1.8.5h.9c.9 0 1.9-.2 2.7-.6L40 13.2zm0 0" :fill="_fill" /></g>
  </svg>
</template>

<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
